import React from "react";
import './class-performance-report.scss';
import { getImageSource } from "../../../../utility/image-source";
import { ImageConstants, Constants } from "../../../../constants/constants";
import Loading from "../../../common/loading/loading";
import SessionCache from "../../../routes/session-cache";
// import { CircularProgressbar } from "react-circular-progressbar";
import ReactTooltip from 'react-tooltip';
import CommonApi from "../../../../apis/common";
import { saveAs } from 'file-saver';
import HomeworkForClickerPracticeApi from "../../../../apis/homework-for-clicker-practice";


const greenColor = '#45CA73'

class ClassPerformanceReport extends React.Component {

    state = {
    }

    componentDidMount() {
        console.log(this.props.selectedItem)
        let userInfo = SessionCache.getUser()
        this.setState({ userInfo })

        this.getClassPerformanceReport()
    }


    getClassPerformanceReport() {

        let payload = {
            homeworkId: this.props.selectedItem._id,
            classText: this.props.selectedItem.class,
            board: this.props.selectedItem.board,
            type: this.props.selectedItem.type,
            sectionId: this.props.selectedItem.sectionId,
            masterDataId: this.props.selectedItem.masterDataId,
            chapterKey: this.props.selectedItem.chapterKey
        }

        this.setState({ isLoading: true })

        HomeworkForClickerPracticeApi.getClassPerformanceReport(payload).then(res => {
            console.log(res)
            this.setState({ ...res, isLoading: false })

        }).catch(err => {
            console.log(err)
        })
    }


    onClickBack() {
        this.props.close && this.props.close()
    }



    capitalizeWords(input) {
        return input
            .split(' ') // Split the string into an array of words
            .map(word =>
                word
                    .split('.') // Split the word by dots
                    .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()) // Capitalize each part
                    .join('.') // Rejoin the parts with dots
            )
            .join(' '); // Join the words back into a single string
    }


    getDate = (timeStamp, getYear) => {

        let dateFormat = new Date(timeStamp).toDateString();

        let date = dateFormat.split(" ")[2];

        let month = dateFormat.split(" ")[1];

        let year = dateFormat.split(" ")[3];

        if (getYear) {
            return date + " " + month + " " + year;
        } else {
            return date + " " + month;
        }
    }

     downloadPDF() {
        const link = document.createElement("a");
        link.href = this.state.link
        link.target = "_blank"; 
        link.download = "Student_Performance_Report.pdf"; // name for downloaded file
        link.click();
    }


    render() {

        return (
            <div>
                <div className="class-performance-report">
                    {
                        this.state.isLoading ? <Loading />
                            :
                            <>
                                <div>
                                    <img alt="" className='back-icon cursor-pointer mb-3' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                                </div>
                                <div className="school-name">Students Performance Report</div>
                                <div className="d-flex justify-content-between align-items-center  mb-3">
                                    <div className="header-subtext">{this.state?.userInfo?.schoolInfo?.name}</div>
                                    <div className="d-flex ">
                                        {/* <div className="export-button cursor-pointer mr-3" onClick={() => this.downloadExcelReport()}>Export to Excel</div> */}
                                        <div className="export-button cursor-pointer mr-4" onClick={() => this.downloadPDF()}>{this.state.isDownloading ? 'Downloading...' : 'Download PDF'}</div>
                                    </div>
                                </div>
                                <div className="student-basic-details mt-3">
                                    <div className="student-detail-header">Summary</div>
                                    <div className="row justify-content-between">
                                        <div className="student-details-wrapper col d-flex mt-3 justify-content-start flex-column">
                                            <div className=" d-flex align-items-center pr-0 pl-0 mt-1">
                                                <div className="student-name"><span className="d-inline-block padding-for-class">{`Class`}</span> <span className="light-text" style={{ whiteSpace: "pre" }}>{this.props.selectedItem.class ? `:  ${this.props.selectedItem.class.split(' ')[1]}` : 'Class'} {this.props.selectedItem.section ? this.props.selectedItem.section : ''}</span></div>
                                            </div>
                                            <div className=" d-flex align-items-center pr-0 pl-0 mt-1">
                                                <div className="student-name"><span className="d-inline-block padding-for-date">{`Date`}</span> <span className="light-text" style={{ whiteSpace: "pre" }}>:  {this.getDate(this.props?.selectedItem?.createdDateTimestamp, true)}</span></div>
                                            </div>
                                            <div className=" d-flex align-items-center pr-0 pl-0 mt-1">
                                                <div className="student-name"><span className="d-inline-block padding-for-chapter">{`Chapter`}</span><span className="light-text" style={{ whiteSpace: "pre" }}>:  {this.state.chapterTitle} </span> </div>
                                            </div>
                                            <div className=" d-flex align-items-center pr-0 pl-0 mt-1">
                                                <div className="student-name"><span className="d-inline-block padding-for-duration">{`Duration`}</span><span className="light-text" style={{ whiteSpace: "pre" }}>:  {this.props?.selectedItem?.time}mins </span> </div>
                                            </div>
                                            <div className=" d-flex align-items-center pr-0 pl-0 mt-1">
                                                <div className="student-name"><span className="d-inline-block padding-for-mark">{`Total Mark`}</span><span className="light-text" style={{ whiteSpace: "pre" }}>:  {this.props?.selectedItem?.totalMarks} </span> </div>
                                            </div>
                                            {/* <div className=" d-flex align-items-center pr-0 pl-0 mt-1">
                                                <div className="student-name d-flex flex-column">Concepts :
                                                    {
                                                        this.state.conceptTitleList?.map(item => (
                                                            <div className="light-text" style={{ whiteSpace: "pre" }}>
                                                                {item}, </div>
                                                        ))
                                                    }
                                                </div>

                                            </div> */}
                                        </div>
                                        <div className="student-details-wrapper col d-flex mt-3 flex-column justify-content-start">
                                            <div className=" d-flex align-items-center pr-0 pl-0 mt-1">
                                                <div className="student-name"><span className="d-inline-block padding-for-questions">{`Total Questions`}</span> <span className="light-text" style={{ whiteSpace: "pre" }}>{this.props.selectedItem.questions ? `:  ${this.props.selectedItem.questions}` : '0'}</span></div>
                                            </div>
                                            <div className=" d-flex align-items-center pr-0 pl-0 mt-1">
                                                <div className="student-name"><span className="d-inline-block padding-for-students">{`Total Students`}</span> <span className="light-text" style={{ whiteSpace: "pre" }}>:  {this.state.summary?.totalStudents}</span></div>
                                            </div>
                                            <div className=" d-flex align-items-center pr-0 pl-0 mt-1">
                                                <div className="student-name"><span className="d-inline-block padding-for-attempted">{`Total Attempted`}</span> <span className="light-text" style={{ whiteSpace: "pre" }}>:  {this.state.summary?.totalCompletedStudents}</span></div>
                                            </div>
                                            <div className=" d-flex align-items-center pr-0 pl-0 mt-1">
                                                <div className="student-name"><span className="d-inline-block" style={{paddingRight: "0.8rem"}}>{`Questions Accuracy`} </span> <span className="light-text" style={{ whiteSpace: "pre" }}>:  {this.state.summary?.accuracyPercentage}% </span> </div>
                                            </div>
                                            <div className=" d-flex align-items-center pr-0 pl-0 mt-1">
                                                <div className="student-name"><span className="d-inline-block" style={{paddingRight: "4rem"}}>{`Average Score`} </span> <span className="light-text" style={{ whiteSpace: "pre" }}>:  {`${this.state.studentDetails && this.state.studentDetails.length ? this.state.studentDetails[this.state.studentDetails.length - 1].scorePercentage + '%' : '0 %'}`} </span> </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="performance-overview mt-3 mb-5">
                                        <div className="student-detail-header">Student Performance Details</div>
                                        <div className="competency-table mt-4 table-responsive card">
                                            <table className="table table-bordered table-striped" style={{}}>
                                                <thead className="class-header">
                                                    <tr className="first-header-bg">
                                                        <th className="" width=''>Rank</th>
                                                        <th className="" width=''>Name</th>
                                                        <th># Questions Attempted</th>
                                                        <th># Questions Correct</th>
                                                        <th>Mark Scored</th>
                                                        <th>% Score</th>
                                                    </tr>
                                                </thead>
                                                <tbody id="rows" className="class-body">
                                                    {
                                                        this.state.studentDetails &&
                                                        this.state.studentDetails.length &&
                                                        this.state.studentDetails.map((item, cidx) => (
                                                            <>
                                                                <tr>
                                                                    <td className={`class-text border-bottom-left-radius ${cidx === this.state.studentDetails.length - 1 ? 'bold-text' : ""}`}>
                                                                        <strong>{item.rank}</strong>
                                                                    </td>
                                                                    <td className={`class-text border-bottom-left-radius ${cidx === this.state.studentDetails.length - 1 ? 'bold-text' : ""}`}>
                                                                        {item.studentName}
                                                                    </td>
                                                                    <td className={`class-text border-bottom-left-radius ${cidx === this.state.studentDetails.length - 1 ? 'bold-text' : ""}`}>
                                                                        {item.questionsAttempted}
                                                                    </td>
                                                                    <td className={`class-text border-bottom-left-radius ${cidx === this.state.studentDetails.length - 1 ? 'bold-text' : ""}`}>
                                                                        {item.questionsCorrect}{cidx === this.state.studentDetails.length - 1 ? ` (${this.state.summary?.accuracyPercentage}%)` : ''}
                                                                    </td>
                                                                    <td className={`class-text border-bottom-left-radius ${cidx === this.state.studentDetails.length - 1 ? 'bold-text' : ""}`}>
                                                                        {item.markScored}
                                                                    </td>
                                                                    <td className={`class-text border-bottom-left-radius ${cidx === this.state.studentDetails.length - 1 ? 'bold-text' : ""}`}>
                                                                        {item.scorePercentage}%
                                                                    </td>
                                                                </tr>
                                                            </>

                                                        ))
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="student-name mt-3">Not Attempted Students : </div>
                                    {
                                        this.state.notAttemptedStudentNameList?.length ?
                                            <>
                                                {
                                                    this.state.notAttemptedStudentNameList.map(item => (
                                                        <div>{item}, </div>
                                                    ))
                                                }
                                            </>
                                            :
                                            <div>No Students</div>
                                    }
                                </div>
                            </>
                    }
                </div>
                <ReactTooltip className="border arrow" arrowColor="#C4C4C4" ref={el => this.tooltip = el}
                    multiline={true} place='bottom' type='light' effect='solid'
                    event="mouseover mouseenter"
                    eventOff="mouseleave mouseout scroll mousewheel blur"
                />
            </div>
        )
    }
}

export default ClassPerformanceReport;